import React from 'react';
import { number, string, shape, func, arrayOf } from 'prop-types';

const PactometroCheck = ({
  data,
  onChange,
  selectedId,
  selecteds,
  selectedsNo
}) => (
  <div
    className="selector-wrapper"
    style={selectedId ? { cursor: 'pointer' } : { pointerEvents: 'none' }}
  >
    {data?.map((item, index) => (
      <div className="selector-item-group" key={item.partyAcronym}>
        <div className="selector-item-item">
          <span
            className="selector-color"
            style={{ backgroundColor: item.partyColor }}
          />
          <p className="selector-party">
            {item.partyAcronym && `${item.partyAcronym}`}{' '}
            <strong>{item.seats && `${item.seats}`}</strong>
          </p>
          <div className="selector-options">
            <div
              className="selector-row"
              role="presentation"
              onClick={() => onChange({ item, pacto: 1 })}
            >
              <input
                id={`selector-si-${index}`}
                className="selector-input"
                type="checkbox"
                onChange={() => {
                  onChange({ item, pacto: 1 });
                }}
                checked={selecteds.some(select => select.id === item.id)}
                style={
                  selecteds.some(select => select.id === item.id)
                    ? {
                        backgroundColor: item.partyColor,
                        border: item.partyColor
                      }
                    : { backgroundColor: '#FFF', borderColor: '#d9d9d9' }
                }
              />
              {/* eslint-disable-next-line */}
              <label
                htmlFor={`selector-si-${index}`}
                className="selector-label"
              >
                SI
              </label>
            </div>
            <div
              className="selector-row"
              role="presentation"
              onClick={() => onChange({ item, pacto: -1 })}
            >
              <input
                id={`selector-abs-${index}`}
                className="selector-input"
                type="checkbox"
                onChange={() => {
                  onChange({ item, pacto: -1 });
                }}
                checked={
                  !selecteds.some(select => select.id === item.id) &&
                  !selectedsNo.some(select => select.id === item.id)
                }
                style={
                  !selecteds.some(select => select.id === item.id) &&
                  !selectedsNo.some(select => select.id === item.id)
                    ? {
                        backgroundColor: item.partyColor,
                        border: item.partyColor
                      }
                    : {
                        backgroundColor: '#FFF',
                        border: '1px solid #d9d9d9'
                      }
                }
              />
              {/* eslint-disable-next-line */}
              <label
                htmlFor={`selector-abs-${index}`}
                className="selector-label"
              >
                ABS
              </label>
            </div>
            <div
              className="selector-row"
              role="presentation"
              onClick={() => onChange({ item, pacto: 0 })}
            >
              <input
                id={`selector-no-${index}`}
                className="selector-input"
                type="checkbox"
                onChange={() => onChange({ item, pacto: 0 })}
                checked={selectedsNo.some(select => select.id === item.id)}
                style={
                  selectedsNo.some(select => select.id === item.id)
                    ? {
                        backgroundColor: item.partyColor,
                        border: item.partyColor
                      }
                    : {
                        backgroundColor: '#FFF',
                        border: '1px solid #d9d9d9'
                      }
                }
              />
              {/* eslint-disable-next-line */}
              <label
                htmlFor={`selector-no-${index}`}
                className="selector-label"
              >
                NO
              </label>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

PactometroCheck.propTypes = {
  data: arrayOf(
    shape({
      partyAcronym: string.isRequired,
      seats: number.isRequired,
      partyColor: string.isRequired,
      votes: number.isRequired,
      id: number.isRequired
    })
  ).isRequired,
  onChange: func.isRequired,
  cols: number,
  selecteds: arrayOf(number),
  selectedsNo: arrayOf(number)
};

PactometroCheck.defaultProps = {
  cols: 3,
  selecteds: [],
  selectedsNo: []
};

export default PactometroCheck;
